import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
export const ChatStartNewEndpointParams = z.object({
    /** Language code for the chat, or null for default */
    lang: z.nullable(z.string()),
    /** UID of the agent to start the chat with */
    agentUid: z.string(),
});
export const ChatStartNewEndpoint = defineEndpoint({
    name: 'ChatStartNew',
    input: ChatStartNewEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=ChatStartNewEndpoint.js.map